import {PaynowChargeHeaderComponent} from './paynowChargeHeader/paynowChargeHeader.component';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {FrontPipesModule} from '../pipes/pipes.module';
import {FrontDirectivesModule} from '../directives/directives.module';
import {OtpSessionShortcutComponent} from './otpSessionShortcut/otpSessionShortcut.component';
import {TranslateModule} from '@ngx-translate/core';
import {SupportButtonComponent} from './supportButton/supportButton.component';
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {SwiperModule} from 'swiper/angular';
import {ChargePointChoiceComponent} from './chargePointChoice/chargePointChoice.component';
import {NewChargeSummaryComponent} from './newChargeSummary/newChargeSummary.component';
import {PlugTypeChoiceComponent} from './plugTypeChoice/plugTypeChoice.component';
import {RemoteComponent} from './remote/remote.component';
import {IziviaFabButtonWithLoaderComponent} from './ui/iziviaFabButtonWithLoader/iziviaFabButtonWithLoader.component';
import {RemoteImgComponent} from './ui/remoteImg/remoteImg.component';
import {PricingContextFormatterComponent} from './pricingContextFormatter/pricingContextFormatter.component';
import {SupportChoiceComponent} from './supportChoice/supportChoice.component';
import {ChargeRecordDetailsComponent} from './events/chargeRecordDetails/chargeRecordDetails.component';
import {OtpDetailsComponent} from './events/otpDetails/otpDetails.component';
import {InfraChargeComponent} from './events/infraCharge/infraCharge.component';
import {HeaderStepsComponent} from './headerSteps/headerSteps.component';
import {SupportContactComponent} from './supportChoice/supportContact/supportContact.component';
import {SupportContactListComponent} from './supportChoice/supportContactList/supportContactList.component';
import {IziviaBackButtonComponent} from './ui/iziviaBackButton/iziviaBackButton.component';
import {ReservationChoiceComponent} from './reservationChoice/reservationChoice.component';
import {ReservationDetailsComponent} from './events/reservationDetails/reservationDetails.component';
import {PictureTextCardComponent} from './ui/pictureTextCard/pictureTextCard.component';
import {IziviaHelpTextComponent} from './ui/iziviaHelpText/iziviaHelpText.component';
import {FaqListComponent} from './faq/faqList/faqList.component';
import {FaqSearchComponent} from './faq/faqSearch/faqSearch.component';
import {FaqFolderComponent} from './faq/faqFolder/faqFolder.component';
import {FaqPageComponent} from './faq/faqPage/faqPage.component';
import {IziviaSlidesComponent} from './ui/iziviaSlides/iziviaSlides.component';
import {FaqFileComponent} from './faq/faqFile/faqFile.component';
import {FaqContactComponent} from './faq/faqContact/faqContact.component';
import {
    IziviaTextButtonWithLoaderComponent
} from './ui/iziviaTextButtonWithLoader/iziviaTextButtonWithLoader.component';
import {FaqModalComponent} from './faq/faqModal/faqModal.component';
import {FaqRootModalComponent} from './faq/faqRootModal/faqRootModal.component';
import {FaqNodeModalComponent} from './faq/faqNodeModal/faqNodeModal.component';
import {CheckboxComponent} from './ui/checkbox/checkbox.component';

const components = [
    PaynowChargeHeaderComponent,
    OtpSessionShortcutComponent,
    SupportButtonComponent,

    ChargePointChoiceComponent,
    NewChargeSummaryComponent,
    PlugTypeChoiceComponent,
    RemoteComponent,
    SupportChoiceComponent,
    HeaderStepsComponent,
    ReservationChoiceComponent,

    // Event
    ChargeRecordDetailsComponent,
    InfraChargeComponent,
    OtpDetailsComponent,
    ReservationDetailsComponent,

    // UI
    IziviaFabButtonWithLoaderComponent,
    IziviaTextButtonWithLoaderComponent,
    IziviaBackButtonComponent,
    IziviaHelpTextComponent,
    IziviaSlidesComponent,
    RemoteImgComponent,
    PictureTextCardComponent,
    CheckboxComponent,

    // Support
    SupportContactComponent,
    SupportContactListComponent,

    // Payment
    PricingContextFormatterComponent,

    // FAQ
    FaqListComponent,
    FaqSearchComponent,
    FaqFolderComponent,
    FaqPageComponent,
    FaqFileComponent,
    FaqContactComponent,
    FaqRootModalComponent,
    FaqNodeModalComponent,
    FaqModalComponent,
];

@NgModule({
    declarations: [components],
    exports: [components],
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        FrontPipesModule,
        FrontDirectivesModule,
        TranslateModule,
        RouterModule,
        SwiperModule
    ]
})
export class ComponentsModule {
}
